(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ROR.Steps",
                {
                    url: "/Steps",
                    component: "steps",
                    PageTitle: "Next Steps",
                    //requiredPermissions: "NewAccountWizard:View"                           
                    resolve: {                    
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],           
                        userOnbordingRecord: ["onboardingApi", function (onboardingApi) {                                                                               
                            return onboardingApi.getLoggedInUserOnboarding().then(function (record) {
                                return record;
                            }, function () {
                                return null;
                            });
                        }],
                        rorSteps: ["masterAdvisorAgreementRequiredRecord", "userOnbordingRecord", "userMasterAdvisorAgreement", function (masterAdvisorAgreementRequiredRecord, userOnbordingRecord, userMasterAdvisorAgreement) {
                            var steps = [];    
                            
                            if (userOnbordingRecord != null) {
                                if (masterAdvisorAgreementRequiredRecord != null)
                                    steps.push({
                                        step: "agreement",
                                        description: "Sign Master Advisor Agreement",
                                        complete: userMasterAdvisorAgreement != null ? true : false
                                    });

                                steps.push({
                                    step: "validate",
                                    description: "Validate your Personal Information",
                                    complete: userOnbordingRecord.InfoValidated != null ? true : false
                                });

                                steps.push({
                                    step: "getcontracted",
                                    description: "Get Contracted!",
                                    complete: false
                                });
                            }
                        
                            return steps;
                        }]
                    }
                });
        }
    ]);

    app.component("steps",
        {
            templateUrl: "App/RORWizard/Steps/steps.html",
            controller: stepsCtrl,
            bindings: {              
                rorSteps: "<",
                user: "<",
                masterAdvisorAgreementRequiredRecord: "<"
            }
        });

    stepsCtrl.$inject = ["$http", "permissionService", "$filter", "$state"];
    
    function stepsCtrl($http, permissionService, $filter, $state) {
        var $ctrl = this;
        
        $ctrl.goToAgreement = ($filter("filter")($ctrl.rorSteps, { step: "agreement" }).length && $filter("filter")($ctrl.rorSteps, { step: "agreement" })[0].complete === false) ? true : false;

        //if we want to hide when they have already validated:
        //$ctrl.goToValidate = ($filter("filter")($ctrl.rorSteps, { step: "validate" }).length && $filter("filter")($ctrl.rorSteps, { step: "validate" })[0].complete === false) ? true : false;

        //always allow them to go back to validate:
        $ctrl.goToValidate = true;

        $ctrl.UI = {};
        $ctrl.UI.prevStage = "intro";
        $ctrl.UI.nextStage = $ctrl.goToAgreement ? "agreement" : $ctrl.goToValidate ? "validate" : "contract";

        $ctrl.changeStage = function (goToStage) {               
            if (goToStage === "intro") {
                $state.go("Home.ROR.Intro");
            }

            if (goToStage === "agreement") {
                $state.go("Home.ROR.Agreement", { "workflow": "ror" });
            }

            if (goToStage === "validate") {
                $state.go("Home.ROR.Validate");
            }      

            if (goToStage === "contract") {
                $state.go("Home.ROR.Contract", { "workflow": "ror" });
            }      
        }
    }
})(window.app, window.angular); // jshint ignore:line